import React from 'react';
import { connect } from 'react-redux';

import { getUserById } from '../../redux/actions/userActions';

type Props = {
  userId: string,
  userData: Object,
  getUserData: (id: string) => void,
};

class User extends React.Component<Props> {
  render() {
    const { children, userData } = this.props;
    return children({ userData: userData ? userData : {} });
  }

  componentDidMount() {
    const { userData, getUserData } = this.props;
    if (!userData) getUserData();
  }

  componentDidUpdate(prevProps) {
    const { userData, getUserData, userId } = this.props;
    if (userId !== prevProps.userId) {
      if (!userData) getUserData();
    }
  }
}

const mapStateToProps = ({ schema }, { userId }) => {
  return {
    userData: schema.users.byId[userId] || null,
  };
};

const mapDispatchToProps = (dispatch, { userId }) => {
  return {
    getUserData: () => dispatch(getUserById(userId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(User);



// WEBPACK FOOTER //
// ./src/components/User/User.jsx